import { GaugeIcon, LayoutGridIcon, ServerIcon, ShieldAlertIcon, ToggleRightIcon, UtilityPoleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Power Distribution Fundamentals: Systems, Voltages, Single-Line Diagrams & Earthing',
    summary: 'A visual technical reference to how electrical power is distributed, drawn and earthed, from the supply point to the load.',
    icon: UtilityPoleIcon,
  },
  {
    number: '02',
    title: 'Low-Voltage Switchboards, MCCs & Panelboards',
    summary: 'A visual technical reference to main switchboards, motor control centres, panelboards, starters, control circuits and metering.',
    icon: LayoutGridIcon,
  },
  {
    number: '03',
    title: 'Medium-Voltage Switchgear: Air, SF6, Vacuum & Ring Main Units',
    summary: 'A visual technical reference to MV panels, interruption technologies, withdrawable breakers, interlocks, earthing switches and ring main units.',
    icon: ServerIcon,
  },
  {
    number: '04',
    title: 'Circuit Breakers, Fuses & Protection Coordination',
    summary: 'A visual technical reference to breakers, trip units, fuses, time-current curves, selectivity, feeder protection and residual current devices.',
    icon: ToggleRightIcon,
  },
  {
    number: '05',
    title: 'Testing, Commissioning & Preventive Maintenance',
    summary: 'A visual technical reference to inspection, thermography, insulation and contact resistance testing, breaker testing, commissioning and maintenance records.',
    icon: GaugeIcon,
  },
  {
    number: '06',
    title: 'Electrical Safety, Arc Flash Awareness & Troubleshooting',
    summary: 'A visual technical reference to electrical hazards, arc flash awareness, PPE, lockout/tagout, testing for absence of voltage and structured fault finding.',
    icon: ShieldAlertIcon,
  },
];
